import { render, staticRenderFns } from "./SettingsAccounting.vue?vue&type=template&id=16e65882&"
import script from "./SettingsAccounting.vue?vue&type=script&lang=js&"
export * from "./SettingsAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports